'use client'
import { Toaster } from 'react-hot-toast'

import type { PropsWithChildren } from 'react'

export const ToastProvider = ({ children }: PropsWithChildren) => (
  <>
    {children}
    <div className="z-99999">
      <Toaster position="top-center" reverseOrder={false} />
    </div>
  </>
)
